// authReducer.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api.js";

// Centralisation des routes API
const API_ROUTES = {
    ADD_BANNER: `/api/banner/add_banner`,
    GET_PRODUCT_BANNER: `/api/banner/get_banner`,
    UPDATE_PRODUCT_BANNER: `/api/banner/update_product_banner`,
    GET_USER: '/api/get_user',
    UPLOAD_IMAGE: '/api/profile/uploadImage',
    LOGOUT: '/api/logout',
    SELLER_INFO : '/api/profile/seller_infos',
};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) => error.response?.data.message || error.message;

// Action pour l'ajout de banner
export const add_banner = createAsyncThunk(
    "banner/add_banner",
    async (formData, { rejectWithValue, fulfillWithValue }) => {
        try {
          /* const formData = new FormData();
           formData.append('productId', productId);
           formData.append('banners', banners);*/

         // console.log("Données FormData avant l'envoi :", formData.get('productId'), formData.get('banners'));
            //console.log('info ', info);

            const { data } = await api.post(API_ROUTES.ADD_BANNER, formData, { withCredentials: true });
           // console.log("Réponse de l'API :", data); // Log de la réponse de l'API

            return fulfillWithValue(data);
        } catch (error) {
            //console.error("Erreur lors de l'ajout de la catégorie", error);
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

// 
export const get_product_banner = createAsyncThunk(
    "banner/get_product_banner",
    async (productId, { rejectWithValue, fulfillWithValue }) => {
        try {
         // console.log("Données FormData avant l'envoi :", formData.get('productId'), formData.get('banners'));

            const { data } = await api.get(`${API_ROUTES.GET_PRODUCT_BANNER}/${productId}`, { withCredentials: true });
           // console.log("Réponse de l'API :", data); // Log de la réponse de l'API

            return fulfillWithValue(data);
        } catch (error) {
           // console.error("erreur getting banner", error);
           // return rejectWithValue(error.response?.data.message || error.message);
           return rejectWithValue(getErrorMessage(error));
        }
    }
);

// Action pour l'ajout de catégorie
export const update_product_banner = createAsyncThunk(
    "banner/update_product_banner",
    async ({bannerId, info}, { rejectWithValue, fulfillWithValue }) => {
        try {
         // console.log("Données FormData avant l'envoi :", formData.get('productId'), formData.get('banners'));

            const { data } = await api.put(`${API_ROUTES.UPDATE_PRODUCT_BANNER}/${bannerId}`,info,{ withCredentials: true });
          // console.log("Réponse de l'API banner updating :", data); // Log de la réponse de l'API

            return fulfillWithValue(data);
        } catch (error) {
            //console.error("erreur updating banner", error);
            //return rejectWithValue(error.response?.data.message || error.message);
            return rejectWithValue(getErrorMessage(error));
        }
    }
);



// Reducer principal
export const bannerReducer = createSlice({
    name: 'banner',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        banner : '',
        banners: [],
        
    },
    
    reducers: {
        messageClear: (state) => {
            state.errorMessage = "";
            state.successMessage = "";
        },
    },
    
    extraReducers: (builder) => {
       builder 
            .addCase(add_banner.pending, (state) => {
                state.loader = true;
                state.errorMessage = "";
                state.successMessage = "";
            })
            .addCase(add_banner.fulfilled, (state, action) => {
                state.loader = false;
                state.successMessage = action.payload.message;
                state.banner = action.payload.bannerImage;
            })
            .addCase(add_banner.rejected, (state, action) => {
                state.loader = false;
                state.errorMessage = action.payload.message || 'Donnée invalide';
            })

            .addCase(get_product_banner.pending, (state)=>{
                state.loader = true;
                state.errorMessage = "";
                state.successMessage = "";
            })
            .addCase(get_product_banner.fulfilled, (state, action) => {
                state.loader = false;
                state.successMessage = action.payload.message;
                state.banner = action.payload.banner;
            })
            .addCase(get_product_banner.rejected, (state, action) => {
                state.loader = false;
                state.errorMessage = action.payload.message;
            })

            .addCase(update_product_banner.pending, (state)=>{
                state.loader = true;
                state.errorMessage = "";
                state.successMessage = "";
            })
            .addCase(update_product_banner.fulfilled, (state, action)=>{
                state.loader = false;
                state.successMessage = action.payload.message;
                state.banner = action.payload.banner;
            })
            .addCase(update_product_banner.rejected, (state, action) => {
                state.loader = false;
                state.errorMessage = action.payload.message || 'Echec de mise à jour du banner';
            })



    }
});

export const { messageClear } = bannerReducer.actions;
export default bannerReducer.reducer;
